import { MaskService } from '@shared/services/mask.service';
import { CustomDateAdapter } from '@shared/services/custom-date-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

// Material Imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingBoxComponent } from '../../../../../shared/components/loading-box/loading-box.component';
import { EmptyListComponent } from '../../../../../shared/components/empty-list/empty-list.component';
import { FooterActionComponent } from '../../../../../shared/components/footer-action/footer-action.component';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';
import { FiltroPainelNotaRecebidaComponent } from './componentes-filtro/filtro-painel-nota-recebida/filtro-painel-nota-recebida.component';
import { FiltroPainelContadorComponent } from './componentes-filtro/filtro-painel-contador/filtro-painel-contador.component';
import { ModuloEnum } from '../../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../../shared/enums/usuario/funcionalidade.enum';
import { TipoExtracao } from '../../../../../shared/services/models/batch-extracao-dados/tipo-extracao.model';
import { TipoExtracaoEnum } from '../../../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { TipoRecorrenciaEnum } from '../../../../../shared/enums/batch-extracao-dados/tipo-recorrencia.enum';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { AutomacaoExtracaoDadosService } from '../../../../../shared/services/apis/batch-extracao-dados/automacao-extracao-dados.service';
import { BatchExtracaoDadosLookupService } from '../../../../../shared/services/apis/batch-extracao-dados/batch-extracao-dados-lookup.service';
import { PerfilService } from '../../../../../shared/services/apis/usuario/perfil.service';
import { TipoRecorrencia } from '../../../../../shared/services/models/batch-extracao-dados/tipo-recorrencia.model';
import { Perfil } from '../../../../../shared/services/models/usuario/perfil.model';
import { AutomacaoExtracaoDadosRequest } from '../../../../../shared/services/requests/batch-extracao-dados/automacao-extracao-dados.request';
import { BatchExtracaoDadosLookupResponse } from '../../../../../shared/services/responses/batch-extracao-dados/batch-extracao-dados-lookup.response';
import { GetAutomacaoExtracaoDadosResponse } from '../../../../../shared/services/responses/batch-extracao-dados/get-automacao-extracao-dados.response';
import { AutomacaoExtracaoDadosHistoricoStruct } from '../../../../../shared/services/structs/batch-extracao-dados/automacao-extracao-dados-historico.struct';
import { HeaderComponent } from '../../../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../../../shared/components/ui-tag/ui-tag.component';
import { StatusExtracaoEnum } from '../../../../../shared/enums/batch-extracao-dados/status-extracao.enum';

// Shared


@Component({
  selector: 'app-automacao-extracao-dados-cadastro',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    LoadingBoxComponent,
    EmptyListComponent,
    // Material
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    // Filtros
    FiltroPainelContadorComponent,
    FiltroPainelNotaRecebidaComponent,
    AlertCardComponent,
    FooterActionComponent,
    HeaderComponent,
    UiTagComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  templateUrl: './automacao-extracao-dados-cadastro.component.html',
  styleUrl: './automacao-extracao-dados-cadastro.component.css'
})
export class AutomacaoExtracaoDadosCadastroComponent implements OnInit {
  public readonly onDateInput = MaskService.onDateInput;
  public moduloEnum = ModuloEnum.Home;
  public funcionalidadeEnum = FuncionalidadeEnum.Home_Ferramentas;

  public model: FormGroup;
  public isEdicao: boolean = false;
  public isLoading: boolean = false;
  public idAutomacaoExtracaoDados: number | null = null;
  public jsonFiltrosEdicao: string = '{}';
  public preselectedTipoExtracao: number | null = null;

  @ViewChild(FiltroPainelContadorComponent) filtroContadorComponent!: FiltroPainelContadorComponent;
  @ViewChild(FiltroPainelNotaRecebidaComponent) filtroNotaRecebidaComponent!: FiltroPainelNotaRecebidaComponent;

  public listaTiposExtracao: TipoExtracao[] = [];
  public listaTiposRecorrencia: TipoRecorrencia[] = [];
  public listaPerfis: Perfil[] = [];

  public diasSemana = [
    { id: 0, label: 'Domingo' },
    { id: 1, label: 'Segunda-feira' },
    { id: 2, label: 'Terça-feira' },
    { id: 3, label: 'Quarta-feira' },
    { id: 4, label: 'Quinta-feira' },
    { id: 5, label: 'Sexta-feira' },
    { id: 6, label: 'Sábado' }
  ];
  public diasMes = Array.from({ length: 31 }, (_, i) => i + 1);

  // Tipagem correta com a Struct
  public dataSourceHistorico = new MatTableDataSource<AutomacaoExtracaoDadosHistoricoStruct>();
  public displayedColumnsHistorico: string[] = [
    'idAutomacaoExtracaoDadosHistorico',
    'datetimeProcessamento',
    'status',
    'action-download'
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private automacaoService: AutomacaoExtracaoDadosService,
    private lookupService: BatchExtracaoDadosLookupService,
    private perfilService: PerfilService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    const params = this.activatedRoute.snapshot.params;
    if (params && params['idTipoExtracao']) {
      this.preselectedTipoExtracao = Number(params['idTipoExtracao']);
    }
    this.model = this.formBuilder.group({
      nomeAutomacao: ['', Validators.required],
      datetimeInicio: [null, Validators.required],
      valorRecorrencia: [null, [Validators.required, Validators.min(0)]],
      idTipoRecorrencia: [null, Validators.required],
      listIdPerfil: [[], Validators.required],
      ativo: [true],
      idTipoExtracao: [this.preselectedTipoExtracao ? this.preselectedTipoExtracao : null, Validators.required]
    });

    this.carregarLookups();
    this.carregarPerfis();
  }

  public onTipoRecorrenciaChange(): void {
    this.model.get('valorRecorrencia')?.setValue(null);
    this.model.get('valorRecorrencia')?.markAsUntouched();
  }

  private carregarLookups(): void {
    this.isLoading = true;
    this.lookupService.get().subscribe({
      next: (res: BatchExtracaoDadosLookupResponse) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.listaTiposExtracao = res.listTipoExtracao.filter(x => x.possuiAutomacao === true);
        this.listaTiposRecorrencia = res.listTipoRecorrencia;

        if (this.listaTiposRecorrencia.length > 0 && !this.model.get('idTipoRecorrencia')?.value) {
          this.model.get('idTipoRecorrencia')?.setValue(this.listaTiposRecorrencia[0].idTipoRecorrencia);
        }
        this.verificarModoTela();
      },
      error: (e) => {
        this.alertService.show('Erro', 'Falha ao carregar tipos.', AlertType.error);
        this.isLoading = false;
      }
    });
  }

  carregarPerfis() {
    this.perfilService.getAllLookup().subscribe({
      next: (res) => {
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.listaPerfis = res.listaPerfil.map(lp => lp.perfil);
      }
    });
  }

  private verificarModoTela(): void {
    const params = this.activatedRoute.snapshot.params;
    if (params && params['idAutomacaoExtracaoDados']) {
      this.idAutomacaoExtracaoDados = Number(params['idAutomacaoExtracaoDados']);
      this.isEdicao = true;
      this.carregarDadosEdicao(this.idAutomacaoExtracaoDados);
    } else {
      this.isLoading = false;
    }
  }

  private carregarDadosEdicao(id: number): void {
    this.isLoading = true;
    this.automacaoService.getById(id).subscribe({
      next: (res: GetAutomacaoExtracaoDadosResponse) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.router.navigate(['/home/ferramentas/automacao-extracao-dados']);
          return;
        }

        const auto = res.automacaoExtracaoDados;
        this.jsonFiltrosEdicao = auto.jsonFiltros || '{}';

        this.model.patchValue({
          nomeAutomacao: auto.nomeAutomacao,
          datetimeInicio: auto.datetimeInicio,
          idTipoRecorrencia: auto.idTipoRecorrencia,
          valorRecorrencia: auto.valorRecorrencia,
          ativo: auto.ativo,
          idTipoExtracao: auto.idTipoExtracao,
          listIdPerfil: res.listIdPerfil || [],
        }, { emitEvent: false }); // Previne disparo do valueChanges se houvesse

        // Popula a tabela com a struct que contém isLinkExpired
        this.dataSourceHistorico.data = res.listHistoricoAutomacao || [];

        this.aplicarRegraImutabilidade();
      },
      error: (err) => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Erro ao carregar automação', AlertType.error);
      }
    });
  }

  private aplicarRegraImutabilidade(): void {
    this.model.disable();
    this.model.get('listIdPerfil')?.enable();
    this.model.get('ativo')?.enable();
  }

  public salvar(): void {
    if (this.model.invalid) {
      this.model.markAllAsTouched();
      this.alertService.show('Atenção', 'Preencha todos os campos obrigatórios.', AlertType.warning);
      return;
    }

    this.isLoading = true;
    const formVal = this.model.getRawValue();

    let filtrosObj = {};
    if (this.isFiltroContador && this.filtroContadorComponent) {
      filtrosObj = this.filtroContadorComponent.getValues();
    } else if (this.isFiltroNotaRecebida && this.filtroNotaRecebidaComponent) {
      filtrosObj = this.filtroNotaRecebidaComponent.getValues();
    }

    const request: AutomacaoExtracaoDadosRequest = {
      nomeAutomacao: formVal.nomeAutomacao,
      ativo: formVal.ativo,
      idTipoExtracao: formVal.idTipoExtracao,
      datetimeInicio: formVal.datetimeInicio,
      idTipoRecorrencia: formVal.idTipoRecorrencia,
      valorRecorrencia: formVal.valorRecorrencia,
      listIdPerfil: formVal.listIdPerfil,
      jsonFiltros: JSON.stringify(filtrosObj)
    };

    if (this.isEdicao && this.idAutomacaoExtracaoDados) {
      this.automacaoService.put(this.idAutomacaoExtracaoDados, request).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res.isError) {
            this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
            return;
          }
          this.alertService.show('Sucesso', 'Automação atualizada com sucesso!', AlertType.success);
          this.router.navigate(['/home/ferramentas/automacao-extracao-dados']);
        },
        error: (err) => {
          this.isLoading = false;
          this.alertService.show('Erro inesperado', err.message, AlertType.error);
        }
      });
    } else {
      this.automacaoService.post(request).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res.isError) {
            this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
            return;
          }

          this.alertService.show('Sucesso', 'Automação criada com sucesso!', AlertType.success);
          this.router.navigate(['/home/ferramentas/automacao-extracao-dados']);
        },
        error: (err) => {
          this.isLoading = false;
          this.alertService.show('Erro inesperado', err.message, AlertType.error);
        }
      });
    }
  }

  // --- MÉTODOS DE DOWNLOAD E TOOLTIP ---

  public getTooltipDownload(element: AutomacaoExtracaoDadosHistoricoStruct): string {
    const url = element.automacaoExtracaoDadosHistorico.urlArquivo;

    if (element.isLinkExpired) {
      return 'Link expirado. O arquivo só fica disponível por 7 dias após o envio.';
    }

    if (!url) {
      return 'Arquivo não disponível ou não gerado.';
    }

    return 'Baixar arquivo';
  }

  // --- MÉTODOS DE STATUS ---

  public isProcessadoComErro(element: AutomacaoExtracaoDadosHistoricoStruct): boolean {
    return element.automacaoExtracaoDadosHistorico.idStatusExtracao === StatusExtracaoEnum.ProcessadoComErro;
  }

  public getTooltipStatus(element: AutomacaoExtracaoDadosHistoricoStruct): string {
    if (!this.isProcessadoComErro(element)) {
      return '';
    }
    return element.automacaoExtracaoDadosHistorico.mensagemErro || 'Erro não informado.';
  }

  public getColorClassStatus(element: AutomacaoExtracaoDadosHistoricoStruct): string {
    switch (element.automacaoExtracaoDadosHistorico.idStatusExtracao) {
      case StatusExtracaoEnum.ProcessadoComSucesso: return 'badge-verde';
      case StatusExtracaoEnum.ProcessadoComErro: return 'badge-vermelho';
      case StatusExtracaoEnum.EmProcessamento: return 'badge-azul';
      default: return 'badge-cinza';
    }
  }

  public getIconStatus(element: AutomacaoExtracaoDadosHistoricoStruct): string {
    switch (element.automacaoExtracaoDadosHistorico.idStatusExtracao) {
      case StatusExtracaoEnum.ProcessadoComSucesso: return 'check_circle';
      case StatusExtracaoEnum.ProcessadoComErro: return 'error';
      case StatusExtracaoEnum.EmProcessamento: return 'sync';
      default: return 'schedule';
    }
  }

  public baixarArquivo(element: AutomacaoExtracaoDadosHistoricoStruct): void {
    if (element.isLinkExpired) {
      this.alertService.show('Link Expirado', 'Este arquivo não está mais disponível para download (Prazo de 7 dias excedido).', AlertType.warning);
      return;
    }

    const url = element.automacaoExtracaoDadosHistorico.urlArquivo;
    if (!url) {
      this.alertService.show('Aviso', 'URL do arquivo não disponível.', AlertType.info);
      return;
    }
    window.open(url, '_blank');
  }

  public cancelar(): void {
    this.router.navigate(['/home/ferramentas/automacao-extracao-dados']);
  }

  public get isSemanal(): boolean {
    return this.model.get('idTipoRecorrencia')?.value === TipoRecorrenciaEnum.Semanal;
  }

  public get isMensal(): boolean {
    return this.model.get('idTipoRecorrencia')?.value === TipoRecorrenciaEnum.Mensal;
  }

  public get nomeTipoExtracao(): string {
    const tipo = this.listaTiposExtracao.find(t => t.idTipoExtracao === this.model.get('idTipoExtracao')?.value);
    return tipo?.tipoExtracao || '';
  }

  public get isFiltroContador(): boolean {
    const tipo = this.model.get('idTipoExtracao')?.value;
    return tipo === TipoExtracaoEnum.NotaXml || tipo === TipoExtracaoEnum.NotaCsv || tipo === TipoExtracaoEnum.RelatorioProdutoNFeNFCe;
  }

  public get isFiltroNotaRecebida(): boolean {
    const tipo = this.model.get('idTipoExtracao')?.value;
    return tipo === TipoExtracaoEnum.NotaRecebidaXml || tipo === TipoExtracaoEnum.NotaRecebidaCsv;
  }

  public onDateKeydown(event: KeyboardEvent): void {
    const permitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
    const atalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
    if (permitidas.includes(event.key) || atalho) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }
}
